import gySVG from '../src/index.js';

(typeof gobalThis !== 'undefined' ? globalThis : window).gySVG = gySVG;